var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.476 12.447A5.982 5.982 0 0 0 13.2 12h-2.4a6 6 0 0 0-6 6v2.4h8.811a4.802 4.802 0 0 1 1.865-7.953ZM15.6 7.2a3.6 3.6 0 1 0-7.2 0 3.6 3.6 0 0 0 7.2 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Zm0 .6a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4Zm.392 6.375V20h-.78v-.825h.78ZM17.008 14c.545 0 .98.157 1.305.47.325.315.487.694.487 1.14 0 .257-.057.495-.171.712-.102.193-.29.423-.563.69l-.187.178-.139.137a2.097 2.097 0 0 0-.219.25c-.068.1-.119.214-.152.342a2.59 2.59 0 0 0-.054.509l-.003.12h-.658l-.004-.218c0-.284.038-.53.114-.736.056-.156.146-.313.27-.471l.044-.053.114-.125.15-.15.185-.177c.237-.222.391-.398.462-.53a.89.89 0 0 0 .107-.43c0-.282-.104-.53-.312-.743a1.027 1.027 0 0 0-.765-.32.997.997 0 0 0-.73.29c-.174.172-.295.43-.362.773l-.023.133-.704-.089.02-.147c.079-.478.26-.85.545-1.116.313-.293.728-.439 1.243-.439Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserQuestion);
export default __webpack_public_path__ + "static/media/user-question.ca192702.svg";
export { ForwardRef as ReactComponent };